/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(82);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module("snail", ["sn.components", _index2.default]);

/***/ },

/***/ 68:
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AlertController = (function () {
		function AlertController($scope, AlertService) {
			_classCallCheck(this, AlertController);
	
			this.AlertService = AlertService;
	
			$scope.myAlert = this.myAlert.bind(this);
			$scope.myAlertWithHint = this.myAlertWithHint.bind(this);
			$scope.myConfirm = this.myConfirm.bind(this);
		}
	
		_createClass(AlertController, [{
			key: "myAlert",
			value: function myAlert() {
				this.AlertService.alert({
					title: "测试",
					content: "你好，我是警告"
				}).then(function () {
					alert("你刚才点了确定");
				});
			}
		}, {
			key: "myAlertWithHint",
			value: function myAlertWithHint() {
				this.AlertService.alert({
					title: "测试",
					content: "你好，我是警告",
					hint: ["操作提示1", "如果想要在操作的时候给点提示，那就写在这里"]
				}).then(function () {
					alert("你刚才点了确定");
				});
			}
		}, {
			key: "myConfirm",
			value: function myConfirm() {
				this.AlertService.confirm({
					title: "测试",
					contents: ["你好，确定要删除以下内容吗？", "aaa, bbb"]
				}).then(function () {
					alert("你刚才点了确定");
				}, function () {
					alert("你刚才点了取消");
				});
			}
		}]);
	
		return AlertController;
	})();
	
	exports.default = AlertController;
	
	AlertController.$inject = ["$scope", "AlertService"];

/***/ },

/***/ 69:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CheckboxController = function CheckboxController($scope) {
		_classCallCheck(this, CheckboxController);
	
		$scope.checkValue = false;
	};
	
	exports.default = CheckboxController;
	
	CheckboxController.$inject = ["$scope"];

/***/ },

/***/ 70:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ContextMenuController = function ContextMenuController($scope) {
		_classCallCheck(this, ContextMenuController);
	
		$scope.students = [{ name: "Tom", age: 18, gender: "Male" }, { name: "Lily", age: 15, gender: "Female" }, { name: "Jerry", age: 14, gender: "Male" }];
	
		$scope.itemMenu = function (student) {
			var arr = [{
				title: "greet",
				action: function action() {
					alert("Hello, I am " + student.name);
				}
			}, {
				title: "divider"
			}, {
				title: "sleep",
				action: function action() {
					alert("zzz");
				}
			}];
	
			if (student.age >= 18) {
				arr.push({
					title: "smoke",
					action: function action() {
						alert("I am adult, I can smoke!");
					}
				});
			}
	
			if (student.gender == "Female") {
				arr.push({
					title: "make up",
					action: function action() {
						alert("I am a girl, am I beautiful?");
					}
				});
			}
	
			return arr;
		};
	};
	
	exports.default = ContextMenuController;
	
	ContextMenuController.$inject = ["$scope"];

/***/ },

/***/ 71:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _checkboxCell = __webpack_require__(125);
	
	var _checkboxCell2 = _interopRequireDefault(_checkboxCell);
	
	var _sortHeaderCell = __webpack_require__(127);
	
	var _sortHeaderCell2 = _interopRequireDefault(_sortHeaderCell);
	
	var _checkboxHeaderCell = __webpack_require__(126);
	
	var _checkboxHeaderCell2 = _interopRequireDefault(_checkboxHeaderCell);
	
	var _buttonCell = __webpack_require__(124);
	
	var _buttonCell2 = _interopRequireDefault(_buttonCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataGridController = function DataGridController($scope) {
		_classCallCheck(this, DataGridController);
	
		$scope.cols = [{ label: "Name", key: "name" }, { label: "Age", key: "age" }, { label: "Gender", key: "gender" }];
	
		$scope.students = [{ name: "Tom", age: 18, gender: "1" }, { name: "Lily", age: 15, gender: "0" }, { name: "Jerry", age: 14, gender: "1" }];
	
		$scope.checkboxCols = [{ label: "", key: "$checked" }, { label: "Name", key: "name" }, { label: "Age", key: "age" }, { label: "Gender", key: "gender" }];
	
		$scope.checkboxTpl = _checkboxCell2.default;
		$scope.sortHeaderTpl = _sortHeaderCell2.default;
	
		$scope.headerSort = function (key) {
			$scope.desc = !$scope.desc;
	
			if ($scope.desc) {
				$scope.students.sort(function (a, b) {
					return a[key] - b[key];
				});
			} else {
				$scope.students.sort(function (a, b) {
					return b[key] - a[key];
				});
			}
		};
	
		$scope.checkboxHeaderTpl = _checkboxHeaderCell2.default;
	
		$scope.buttonCellTpl = _buttonCell2.default;
	
		$scope.buttonCols = [{ label: "", key: "$checked" }, { label: "Name", key: "name" }, { label: "Age", key: "age" }, { label: "Gender", key: "gender" }, { label: "", key: "$operation" }];
	};
	
	exports.default = DataGridController;
	
	DataGridController.$inject = ["$scope"];

/***/ },

/***/ 72:
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DateController = (function () {
		function DateController() {
			_classCallCheck(this, DateController);
	
			this.oneDay = new Date(2012, 3, 9);
			this.anotherDay = new Date(2012, 11, 2, 3, 4, 5);
	
			this.year = this.oneDay.getFullYear();
			this.month = this.oneDay.getMonth();
			this.date = this.oneDay.getDate();
	
			this.min = new Date(2015, 8, 3);
			this.max = new Date(2016, 2, 1);
	
			this.fromDate = new Date(1995, 1, 3);
			this.toDate = new Date(2016, 7, 6);
	
			this.hour = 3;
			this.minute = 4;
			this.second = 5;
		}
	
		_createClass(DateController, [{
			key: "click",
			value: function click() {
				alert(111);
			}
		}]);
	
		return DateController;
	})();
	
	exports.default = DateController;

/***/ },

/***/ 73:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.TestDialogController = exports.DialogController = undefined;
	
	var _testDialog = __webpack_require__(128);
	
	var _testDialog2 = _interopRequireDefault(_testDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DialogController = exports.DialogController = (function () {
		function DialogController(DialogService) {
			_classCallCheck(this, DialogController);
	
			this.DialogService = DialogService;
	
			this.name = "aaaa";
		}
	
		_createClass(DialogController, [{
			key: "myDialog",
			value: function myDialog() {
				var _this = this;
	
				this.DialogService.modal(_testDialog2.default, { name: "pass in: " + this.name }, function (result) {
					return _this.name = result.name;
				});
			}
		}]);
	
		return DialogController;
	})();
	
	DialogController.$inject = ["DialogService"];
	
	var TestDialogController = exports.TestDialogController = (function () {
		function TestDialogController() {
			_classCallCheck(this, TestDialogController);
		}
	
		_createClass(TestDialogController, [{
			key: "ok",
			value: function ok() {
				this.dialog.onOk(this.dialog.data);
			}
		}]);
	
		return TestDialogController;
	})();

/***/ },

/***/ 74:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HintController = function HintController($scope, HintService) {
		_classCallCheck(this, HintController);
	
		$scope.hintContent = "测试操作结果a";
	
		$scope.myHint = function () {
			HintService.hint({ title: "我操作成功了", content: "结果是：" + $scope.hintContent });
		};
	};
	
	exports.default = HintController;
	
	HintController.$inject = ["$scope", "HintService"];

/***/ },

/***/ 75:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ListController = function ListController() {
		_classCallCheck(this, ListController);
	
		this.listData = Array.from(Array(10000), function (v, i) {
			return { index: i, label: "Item" + i };
		});
		this.selectedItem = null;
	};
	
	exports.default = ListController;

/***/ },

/***/ 76:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NumberController = function NumberController($scope) {
		_classCallCheck(this, NumberController);
	
		$scope.value = 5;
	
		$scope.maxValue = 11;
	};
	
	exports.default = NumberController;
	
	NumberController.$inject = ["$scope"];

/***/ },

/***/ 77:
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PagerController = (function () {
		function PagerController($scope) {
			_classCallCheck(this, PagerController);
	
			this.count = 177;
	
			$scope.$watch("pageCtrl.currentPage", function (page) {
				console.log(page);
			});
		}
	
		_createClass(PagerController, [{
			key: "changeIndex",
			value: function changeIndex() {
				this.currentPage = 1;
			}
		}]);
	
		return PagerController;
	})();
	
	exports.default = PagerController;
	
	PagerController.$inject = ["$scope"];

/***/ },

/***/ 78:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectController = function SelectController($scope) {
		_classCallCheck(this, SelectController);
	
		$scope.options = [{ name: "aaa", value: 111 }, { name: "bbb", value: 222 }, { name: "ccc", value: 333 }, "seperator", { name: "ddd", value: 444 }, { name: "eee", value: 555 }];
	};
	
	exports.default = SelectController;
	
	SelectController.$inject = ["$scope"];

/***/ },

/***/ 79:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ToolTipController = function ToolTipController($scope) {
		_classCallCheck(this, ToolTipController);
	};
	
	exports.default = ToolTipController;
	
	ToolTipController.$inject = ["$scope"];

/***/ },

/***/ 80:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TreeController = function TreeController($scope) {
		_classCallCheck(this, TreeController);
	
		$scope.areaData = [{
			name: "Jiangsu",
			code: "js",
			children: [{
				name: "Nanjing",
				code: "nj"
			}, {
				name: "Suzhou",
				code: "sz",
				children: [{
					name: "Wujiang",
					code: "wj"
				}, {
					name: "Changshu",
					code: "cs"
				}]
			}]
		}, {
			name: "Yunnan",
			code: "yn"
		}, {
			name: "Fujian",
			code: "fj"
		}];
	
		$scope.$on("sn.controls.tree:selectedNodeChanged", function (evt, data) {
			$scope.selectedTreeItem = data.newNode;
		});
	
		$scope.getCheckedItems = function () {
			console.table(getCheckedItems($scope.areaData));
		};
	
		$scope.expandAll = function () {
			$scope.areaData.forEach(function (it) {
				return expandItem(it, true);
			});
		};
	
		$scope.collapseAll = function () {
			$scope.areaData.forEach(function (it) {
				return expandItem(it, false);
			});
		};
	
		function expandItem(data, flag) {
			if (data.children) {
				data.$expanded = flag;
	
				data.children.forEach(function (it) {
					return expandItem(it, flag);
				});
			}
		}
	
		function getCheckedItems(data) {
			var result = [];
			data.forEach(function (it) {
				if (it.$checked) {
					result.push(it);
				}
	
				if (it.children) {
					result = result.concat(getCheckedItems(it.children));
				}
			});
	
			return result;
		};
	};
	
	exports.default = TreeController;
	
	TreeController.$inject = ["$scope"];

/***/ },

/***/ 81:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TreeSelectController = function TreeSelectController($scope) {
		_classCallCheck(this, TreeSelectController);
	
		$scope.areaData = [{
			name: "江苏",
			code: "js",
			children: [{
				name: "南京",
				code: "nj",
				children: [{
					name: "江宁",
					code: "jn",
					children: [{
						name: "秣陵",
						code: "ml"
					}, {
						name: "湖熟",
						code: "cs"
					}]
				}, {
					name: "溧水",
					code: "ls"
				}]
			}, {
				name: "苏州",
				code: "sz",
				children: [{
					name: "吴江",
					code: "wj"
				}, {
					name: "常熟",
					code: "cs"
				}]
			}]
		}, {
			name: "云南",
			code: "yn"
		}, {
			name: "福建",
			code: "fj"
		}];
	
		$scope.item1 = $scope.areaData[0].children[1];
	};
	
	exports.default = TreeSelectController;
	
	TreeSelectController.$inject = ["$scope"];

/***/ },

/***/ 82:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _alert = __webpack_require__(68);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _hint = __webpack_require__(74);
	
	var _hint2 = _interopRequireDefault(_hint);
	
	var _dialog = __webpack_require__(73);
	
	var _tooltip = __webpack_require__(79);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _contextmenu = __webpack_require__(70);
	
	var _contextmenu2 = _interopRequireDefault(_contextmenu);
	
	var _checkbox = __webpack_require__(69);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _number = __webpack_require__(76);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _date = __webpack_require__(72);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _select = __webpack_require__(78);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _list = __webpack_require__(75);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _tree = __webpack_require__(80);
	
	var _tree2 = _interopRequireDefault(_tree);
	
	var _datagrid = __webpack_require__(71);
	
	var _datagrid2 = _interopRequireDefault(_datagrid);
	
	var _treeselect = __webpack_require__(81);
	
	var _treeselect2 = _interopRequireDefault(_treeselect);
	
	var _pager = __webpack_require__(77);
	
	var _pager2 = _interopRequireDefault(_pager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module("modules.demo", []).controller("AlertController", _alert2.default).controller("HintController", _hint2.default).controller("DialogController", _dialog.DialogController).controller("TestDialogController", _dialog.TestDialogController).controller("ToolTipController", _tooltip2.default).controller("ContextMenuController", _contextmenu2.default).controller("CheckboxController", _checkbox2.default).controller("NumberController", _number2.default).controller("DateController", _date2.default).controller("SelectController", _select2.default).controller("TreeSelectController", _treeselect2.default).controller("PagerController", _pager2.default).controller("ListController", _list2.default).controller("TreeController", _tree2.default).controller("DataGridController", _datagrid2.default).name;

/***/ },

/***/ 124:
/***/ function(module, exports) {

	module.exports = "<td ng-repeat-start=\"col in datagridCtrl.cols\" ng-if=\"$first\">\n\t<input type=\"checkbox\" ng-model=\"item.$checked\" ng-change=\"datagridCtrl.checkItem(item)\"/>\n</td>\n<td ng-repeat-end ng-if=\"!$first\">\n\t<span ng-if=\"(!$last) || (!item.$checked)\">{{item[col.key]}}</span>\n\t\n\t<button ng-if=\"$last && item.$checked\" class=\"btn btn-default\" ng-click=\"item.gender=1-item.gender\">选中的时候可点，变性</button>\n</td>"

/***/ },

/***/ 125:
/***/ function(module, exports) {

	module.exports = "<td ng-repeat-start=\"col in datagridCtrl.cols\" ng-if=\"$first\">\n\t<input type=\"checkbox\" ng-model=\"item.$checked\" ng-change=\"datagridCtrl.checkItem(item)\"/>\n</td>\n<td ng-repeat-end ng-if=\"!$first\">{{item[col.key]}}</td>"

/***/ },

/***/ 126:
/***/ function(module, exports) {

	module.exports = "<th ng-repeat-start=\"col in datagridCtrl.cols\" ng-if=\"$first\">\n\t<input type=\"checkbox\" ng-model=\"datagridCtrl.$allChecked\" ng-change=\"datagridCtrl.checkAll()\"/>\n</th>\n<th ng-repeat-end ng-if=\"!$first\">{{col.label}}</th>"

/***/ },

/***/ 127:
/***/ function(module, exports) {

	module.exports = "<th ng-repeat=\"col in datagridCtrl.cols\">\n\t{{col.label}}\n\t<button class=\"btn btn-xs glyphicon\"\n\t ng-click=\"datagridCtrl.headerSort(col.key)\"\n\t ng-class=\"{'glyphicon-triangle-bottom':!datagridCtrl.desc, 'glyphicon-triangle-top':datagridCtrl.desc}\"></button>\n</th>"

/***/ },

/***/ 128:
/***/ function(module, exports) {

	module.exports = "<div class=\"modal fade in\" ng-controller=\"TestDialogController as dialogCtrl\" ng-init=\"dialogCtrl.dialog=dialog\">\n\t<div class=\"modal-dialog\">\n\t\t<div class=\"modal-content\">\n\t\t\t<div class=\"modal-header\">\n\t\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"dialog.onClose()\"><span\n\t\t\t\t\t\taria-hidden=\"true\">&times;</span><span\n\t\t\t\t\t\tclass=\"sr-only\">Close</span></button>\n\t\t\t\t<h4 class=\"modal-title\">我是一个对话框</h4>\n\t\t\t</div>\n\t\t\t<div class=\"modal-body\">\n\t\t\t\t<form class=\"form-horizontal\" role=\"form\">\n\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t<label class=\"col-sm-2 control-label\">Name</label>\n\n\t\t\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" placeholder=\"Name\" ng-model=\"dialog.data.name\"/>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t\t<div class=\"modal-footer\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"dialogCtrl.ok()\">OK</button>\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"dialog.onCancel()\">Cancel</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"

/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** app.js
 **/